<template>
	<page enable-flex style="background: #fff;">
		<template #head>
			<div class="search-bar">
				<div class="search flex-center">
					<i class="tf-search"></i>
					<input v-model="keyword" ref="searchInput" class="flex-grow" placeholder="请输入/扫描背贴码" @blur="blurHandle" @keyup.enter="blurHandle">
					<div class="search-scan flex-center" @click="scanHandle"><i class="tf-scan"></i></div>
				</div>
			</div>
		</template>

		<template v-if="codeInfo">
			<div class="head">
				<h5>{{productName || '-'}}</h5>
				<p>背贴码：{{codeInfo.produce_unique_code || '-'}} | IMEI：{{codeInfo.produce_imei}}</p>
			</div>
			<c-tab-list :tabs="tabs" @change="data => currentTab = data.value"></c-tab-list>
			<div class="flex-grow" style="overflow: auto;">
				<div v-if="currentTab == 1">
					<c-detail>
						<c-detail-item label="等级">
							<c-state tag async dict="LEVEL_TYPE" :value="codeInfo.level_type"></c-state>
						</c-detail-item>
						<c-detail-item label="类型">
							{{codeInfo.category_name}}
						</c-detail-item>
						<c-detail-item label="采购单">
							<c-link v-if="auth('m_app_purchase_offline') || auth('m_app_purchase_online')" @click="globalDialog('purchaseOrderDetail', {props: {orderId: codeInfo.purchase_order_id}})">{{codeInfo.purchase_code}}</c-link>
							<span v-else>{{codeInfo.purchase_code}}</span>
						</c-detail-item>
						<c-detail-item label="采购价">
							￥{{codeInfo.purchase_price||'-'}}
						</c-detail-item>
						<c-detail-item label="同行价">
							￥{{codeInfo.market_price||'-'}}
						</c-detail-item>
						<c-detail-item label="零售价">
							￥{{codeInfo.retail_price||'-'}}
						</c-detail-item>
						<c-detail-item label="外部订单号">
							{{codeInfo.out_order_number||'-'}}
						</c-detail-item>
						<template v-for="(item, i) in customField">
							<c-detail-item v-if="item.attribute_id!=codeInfo.color_id && item.attribute_id!=codeInfo.memory_id" :key="i" :label="item.attribute_name">
								<span class="field-value">{{ item.attribute_value }}</span>
							</c-detail-item>
						</template>
					</c-detail>
				</div>
				<div v-else-if="currentTab == 2" class="log">
					<c-scroll key="log" scroll-x>
						<ul class="tab flex">
							<li v-for="(item,i) in logTabList" :key="i" :class="{'z-crt': currentLogTab == item.value}" @click="switchLogTab(item.value)">{{item.name}}</li>
						</ul>
					</c-scroll>

					<!--所有动态 / 操作记录：日志列表-->
					<template v-if="currentLogTab === '' || currentLogTab == 1">
						<c-empty v-if="!compLogList.length"></c-empty>
						<div v-if="!logListDevelopState && filteredLogList.length > 5" class="flex-start-center log-develop">
							<p @click="logListDevelopState = true">展开更早的 {{filteredLogList.length - 5}} 条动态...</p>
						</div>
						<ul class="log-list">
							<li v-for="(item,i) in compLogList" :key="i">
								<div class="log-info flex">
									<span>{{i + 1 + filteredLogList.length - compLogList.length}}.</span>
									<p class="flex-grow">
										<span>{{item.create_date}}</span>
										<span style="margin: 0 .5em; color: #000;">{{item.operator_user_name}}</span>
										<span>{{item.action_desc}}</span>
									</p>
								</div>
								<div v-if="item.remark" class="log-remark">{{item.remark}}</div>
							</li>
						</ul>
					</template>

					<!--备注信息：聚合各来源单据创建时填写的备注-->
					<template v-else-if="currentLogTab == 2">
						<c-empty v-if="!remarkList.length" message="暂无备注信息"></c-empty>
						<ul v-else class="log-list">
							<li v-for="(item, i) in remarkList" :key="i">
								<div class="log-info flex">
									<span>{{i + 1}}.</span>
									<p class="flex-grow">
										<span>{{item.create_date}}</span>
										<span style="margin: 0 .5em; color: #000;">{{item.create_user_realname || '-'}}</span>
										<span v-if="item.source_name" class="log-tag">{{item.source_name}}</span>
									</p>
								</div>
								<div v-if="item.remark" class="log-remark">{{item.remark}}</div>
							</li>
						</ul>
					</template>

					<!--维修记录：维修/送修逐条展示，明细展开到分项金额-->
					<template v-else>
						<c-empty v-if="!sortedRepairCards.length" message="暂无维修记录"></c-empty>
						<ul v-else class="log-list">
							<li v-for="(card, i) in sortedRepairCards" :key="i">
								<div class="log-info flex">
									<span>{{i + 1}}.</span>
									<p class="flex-grow">
										<span>{{card.date}}</span>
										<span style="margin: 0 .5em; color: #000;">{{card.user_name || '-'}}</span>
										<span v-if="card.kind == 2" class="log-tag">{{card.completed ? '送修' : '送修中'}}</span>
									</p>
								</div>
								<div v-if="card.completed && card.update_name" class="log-remark">完成：<span style="color: #000;">{{card.update_name}}</span></div>
								<div class="log-remark">{{itemText(card)}}</div>
							</li>
						</ul>
					</template>
				</div>

				<div v-else class="time">
					<c-scroll key="time" scroll-x>
						<ul class="tab flex">
							<li v-for="(item,i) in timeTabList" :key="i" :class="{'z-crt': currentTimeTab == item}" @click="currentTimeTab = item">{{item || '全部'}}</li>
						</ul>
					</c-scroll>
					<c-empty v-if="!compTimeList.length"></c-empty>
					<div v-else class="time-list">
						<table>
							<thead>
								<tr>
									<th>姓名</th>
									<th>部门</th>
									<th>停留时长</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, i) in compTimeList" :key="i">
									<td>{{item.operator_user_name}}</td>
									<td>{{item.operator_dept_name}}</td>
									<td>
										<span v-if="item.total_stay_days >= 1">{{item.total_stay_days}}天</span>
										<span v-else>{{item.total_stay_hours}}小时</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</template>
		<div v-else class="scan flex-grow flex-column flex-center">
			<i class="scan-icon tf">&#xe661;</i>
			<p class="scan-message">请扫描产品背贴码</p>
			<div class="scan-button flex-center" @click="scanHandle"><i class="tf-scan"></i>扫码查询</div>
		</div>
	</page>
</template>

<script>
	export default {
		props: {
			code: String
		},

		data() {
			return {
				keyword: '',
				codeText: '',
				codeInfo: null,
				customField: null,

				tabs: [{
					name: '基础信息',
					value: 1
				}, {
					name: '跟踪记录',
					value: 2
				}, {
					name: '停留时长',
					value: 3
				}],
				currentTab: 2,

				logTabList: [
					{name: '所有动态', value: ''},
					{name: '操作记录', value: 1},
					{name: '备注信息', value: 2},
					{name: '维修记录', value: 3}
				],
				currentLogTab: '',
				logList: [],
				logListDevelopState: false,

				timeTabList: [],
				currentTimeTab: '',
				timeList: [],
                remarkList: [],

				/**维修/送修记录卡片（kind：1维修 2送修），明细异步回填 */
				repairCards: [],
				/**维修项字典 value→name 映射 */
				repairItemMap: {}
			}
		},

		computed: {
			productName() {
				return [this.codeInfo.brand_name, this.codeInfo.spu_model_name, this.codeInfo.color_name, this.codeInfo.memory_name].filter(item => item).join(' ');
			},

			filteredLogList() {
				return this.logList.filter(item => {
					if (!this.currentLogTab) return true;
					//操作记录tab排除维修记录（25），维修记录tab走独立数据源
					return item.log_type == 1;
				});
			},

			compLogList() {
				return this.logListDevelopState ? this.filteredLogList : this.filteredLogList.slice(-5);
			},

			/**维修/送修卡片按时间倒序展示，同分钟时按id倒序兜底 */
			sortedRepairCards() {
				return this.repairCards.slice().sort((a, b) => (b.date || '').localeCompare(a.date || '') || (b.id || 0) - (a.id || 0));
			},

			compTimeList() {
				return this.timeList ? this.timeList.filter(item => !this.currentTimeTab || this.currentTimeTab == item.operator_dept_name) : null;
			}
		},

		watch: {
			codeText(val) {
				this.keyword = val;
				val && this.request({
                    url: '/productCode/queryByCode',
					data: {
						produce_unique_code: val
					},
					success: data => {
						this.codeInfo = data;
						if (data.custom_fields_value_json && data.custom_fields_value_json.attribute) {
							this.customFields = data.custom_fields_value_json.attribute;
						} else if (data.initial_inspection_json && data.initial_inspection_json.attribute) {
							this.customFields = data.initial_inspection_json.attribute;
						}

						this.logListDevelopState = false;
						this.remarkList = [];
						this.repairCards = [];

						this.request({
							url: '/productCode/log/listByCodeId',
							data: {
								produce_unique_code_id: data.id
							},
							success: data => {
								this.logList = data;
							}
						});
						this.request({
							url: '/productCode/downtime/listByCodeId',
							data: {
								produce_unique_code_id: data.id
							},
							success: data => {
								let list = data.map(item => item.operator_dept_name).filter(item => item).reduce((acc, cur) => {
									if(!acc.includes(cur)) acc.push(cur);
									return acc;
								}, [])
								this.timeTabList = [''].concat(list);
								this.timeList = data;
							}
						});

                        this.request({
                            url: '/productCode/remark/listByCodeId',
                            data: {
                                produce_unique_code_id: data.id,
                                produce_unique_code: data.produce_unique_code
                            },
                            success: data => {
                                this.remarkList = data || []
                            }
                        });

						this.loadRepairItemDic();
						this.loadRepairCards(data.id);
					},
					fail: () => {
						this.codeText = '';
					}
				});
			}
		},

		mounted() {
			if (this.code) {
				this.codeText = this.code;
			}
		},

		methods: {
			scanHandle() {
				this.scanCode({
					success: code => {
						this.codeText = code;
					}
				});
			},

			blurHandle() {
				if (this.keyword.trim()) {
					this.codeText = this.keyword.trim();
				}
			},

			/**切换跟踪记录子tab时收起已展开的更早动态 */
			switchLogTab(value) {
				this.currentLogTab = value;
				this.logListDevelopState = false;
			},

			/**加载维修项字典（value→name） */
			loadRepairItemDic() {
				if (Object.keys(this.repairItemMap).length) return;
				this.request({
					url: '/system/dic/options',
					data: {dic_type_code: 'REPAIR_ITEM'},
					success: data => {
						(data || []).forEach(item => {
							this.$set(this.repairItemMap, item.value, item.name);
						});
					}
				});
			},

			/**维修项字典名 */
			repairItemName(id) {
				return this.repairItemMap[id] || id;
			},

			/**维修卡片明细文案：分项名+金额竖线分隔；明细未返回时回退列表接口的聚合文本 */
			itemText(card) {
				if (card.items.length) {
					return card.items.map(item => this.repairItemName(item.repair_item) + ' ￥' + item.repair_amount).join(' | ');
				}
				return card.fallback || '-';
			},

			/**加载维修/送修记录卡片，明细金额走各自详情接口回填 */
			loadRepairCards(productCodeId) {
				this.request({
					url: '/repair/record/listByProduct',
					data: {produce_unique_code_id: productCodeId},
					success: data => {
						let list = (data && data.obj) ? data.obj : (data || []);
						list.forEach(record => {
							let card = {kind: 1, id: record.id, user_name: record.repair_user_name || record.create_user_name, date: record.create_date, items: [],
								fallback: record.repair_item_name ? record.repair_item_name + ' ￥' + record.repair_amount : ''};
							this.repairCards.push(card);
							this.request({
								url: '/repair/record/detail',
								data: {id: record.id},
								success: d => {
									card.items = (d && d.details) || [];
								}
							});
						});
					}
				});
				this.request({
					url: '/repair/delivery/list',
					data: {produce_unique_code_id: productCodeId, page_size: 100},
					success: data => {
						let list = (data && data.obj) ? data.obj : (data || []);
						list.forEach(record => {
							let completed = record.delivery_state == 2;
							let card = {kind: 2, id: record.id, user_name: record.sender_user_name || record.create_user_name, date: completed ? (record.complete_date || record.create_date) : record.create_date, completed: completed, update_name: completed ? (record.update_user_name || '') : '', items: [],
								fallback: record.repair_item_name ? record.repair_item_name + ' ￥' + record.repair_amount : ''};
							this.repairCards.push(card);
							this.request({
								url: '/repair/delivery/detail',
								data: {id: record.id},
								success: d => {
									card.items = (d && d.details) || [];
								}
							});
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.search {
		box-sizing: border-box;
		height: .72rem;
		border-radius: .36rem;
		padding: 0 .14rem 0 .24rem;
		font-size: .28rem;
		color: #bbb;
		background: #F5F5F5;

		&-bar {
			padding: .15rem .24rem .2rem;
		}

		input {
			height: 100%;
			margin-left: .18rem;
			font-size: .26rem;
		}

		&-scan {
			width: .64rem;
			height: .64rem;
			font-size: .36rem;
			color: var(--color-main);
		}
	}

	.scan {
		gap: .28rem;
		padding-bottom: 1.08rem;

		&-icon {
			font-size: 1.08rem;
			color: #ccc;
		}

		&-message {
			font-size: .28rem;
			color: #ccc;
		}

		&-button {
			gap: .22rem;
			width: 4.8rem;
			height: .88rem;
			border-radius: .44rem;
			font-size: .36rem;
			color: #fff;
			background: linear-gradient(90deg, #3D5EFF, #0078FF);
			box-shadow: 0 .04rem .1rem 0 rgba(61,94,255,.3);

			.tf {
				font-size: .4rem;
			}
		}
	}

	.head {
		padding: .26rem;
		font-size: .26rem;
		text-align: center;
		color: #666;
		background: #EFF2FF;

		h5 {
			margin-bottom: .2rem;
			font-size: .32rem;
			color: #000;
		}
	}

	.tab {
		gap: .12rem;
		padding: 0 .2rem;
		margin-top: .24rem;

		li {
			border-radius: .08rem;
			padding: 0 .24rem;
			line-height: .64rem;
			font-size: .26rem;
			white-space: nowrap;
			color: #999;
			background: #F5F7FF;

			&.z-crt {
				color: var(--color-main);
			}
		}
	}
	
	>>> .c-tab-list {
		ul {
			li {
				flex-grow: 1;

				&.z-crt {
					color: var(--color-main);
				}
			}
		}
	}

	.log {
		&-develop {
			position: relative;
			box-sizing: border-box;
			padding: .24rem .32rem 0;
			line-height: .5rem;
			font-size: .26rem;
			text-decoration: underline;
			color: #666;
		}

		&-list {
			padding: .24rem .32rem;

			li {
				padding: .1rem 0;
			}
		}

		&-info {
			gap: .5em;
			line-height: .4rem;
			font-size: .24rem;
			word-break: break-word;
			color: #666;
		}

		&-remark {
			border-radius: .08rem;
			padding: .1rem .2rem;
			margin-top: .1rem;
			line-height: .4rem;
			font-size: .24rem;
			white-space: pre-wrap;
			word-break: break-word;
			background: #F9F9F9;
		}

		.log-tag {
			border: .02rem solid #B9C8FF;
			border-radius: .06rem;
			padding: 0 .1rem;
			margin-left: .12rem;
			line-height: .34rem;
			font-size: .22rem;
			color: var(--color-main);
		}
	}

	.time {
		&-list {
			margin: .24rem;

			table {
				border-spacing: 0;
				table-layout: fixed;
				width: 100%;

				th, td {
					border: .02rem solid #eee;
					padding: 0 .22rem;
					line-height: .7rem;
					font-size: .28rem;
					text-align: left;
				}

				th {
					background: #F9F9F9;
				}
			}
		}
	}
</style>